import { Space, Table } from 'antd';
import { useDepartments } from '../../utils/api-hooks/department.hook';
import { usePagination } from '../../shared/usePagination';
import { Link } from 'react-router-dom';

export default function DepartmentsContainer() {
  const pagination = usePagination();
  const { data: { data, total } = {}, isLoading } = useDepartments();

  return (
    <Space direction="vertical" className="w-full">
      <div className="text-2xl font-bold">部門管理</div>
      <Table
        dataSource={data}
        loading={isLoading}
        rowKey="id"
        scroll={{ x: 'max-content' }}
        size="small"
        pagination={{
          ...pagination,
          total,
        }}
        columns={[
          {
            title: '部門名稱',
            dataIndex: 'name',
            render(value, record) {
              return <Link to={`${record.id}`}>{value}</Link>;
            },
          },
        ]}
      />
    </Space>
  );
}
